import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';
import { ListBatchesResponse, BatchMutationResponse } from '../../types/batch';

const buildQuery = (params: Record<string, string | number | undefined>) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== '') {
      if (Array.isArray(v)) {
        v.forEach((item) => qs.append(k, String(item)));
      } else {
        qs.append(k, String(v));
      }
    }
  });
  const s = qs.toString();
  return s ? `?${s}` : '';
};

export const batchApi = createApi({
  reducerPath: 'batchApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    listBatches: builder.query<
      ListBatchesResponse,
      {
        entityId?: string;
        page?: number;
        perPage?: number;
        type?: string[];
      }
    >({
      query: ({ entityId, page, perPage, type }) => {
        const base = entityId
          ? `api/v1/entities/${entityId}/batches`
          : `api/v1/batches`;

        const qs = buildQuery({
          page,
          perPage,
          type: type?.join('&type[]='),
        });

        return `${base}${qs}`;
      },
    }),
    updateBatch: builder.mutation<BatchMutationResponse, FormData>({
      query: (formData) => ({
        url: 'api/v1/passes/batch/update',
        method: 'POST',
        body: formData,
      }),
    }),
    createBatch: builder.mutation<BatchMutationResponse, FormData>({
      query: (formData) => ({
        url: 'api/v1/passes/batch/',
        method: 'POST',
        body: formData,
      }),
    }),
  }),
});

export const {
  useListBatchesQuery,
  useUpdateBatchMutation,
  useCreateBatchMutation,
} = batchApi;
